module.exports = __webpack_public_path__ + "static/media/report.915f1d03.png";